/* eslint-disable import/no-unresolved */
import {
  ASTRO_PROFILE,
  GET_SECRET_WISH_PLANS,
  CREATE_SECRET_WISH,
  GET_ROMANTIC_HOROSCOPE_HOME,
  UPDATE_ROMANTIC_HOROSCOPE_CONNECTION,
  GET_ROMANTIC_HOROSCOPE_PLANS,
  CREATE_ROMANTIC_HOROSCOPE_PAYMENT_ORDER,
  ASK_ROMANTIC_HOROSCOPE_QUESTION,
  GET_ROMANTIC_HOROSCOPE_QUESTIONS_CHAT,
  GET_ASTRO_CHINESE_HOROSCOPE_PREDICTION,
  GET_ASTRO_FREE_KUNDLI_ASHTAKVARGA,
  GET_ASTRO_FREE_KUNDLI_BASIC,
  GET_ASTRO_FREE_KUNDLI_CHART,
  GET_ASTRO_FREE_KUNDLI_DASHA,
  GET_ASTRO_FREE_KUNDLI_KP,
  GET_ASTRO_FREE_KUNDLI_PLANETS,
  GET_ASTRO_FREE_KUNDLI_REPORT,
  GET_ASTRO_FREE_REPORT_GEMSTONES,
  GET_ASTRO_FREE_REPORT_KAALSARP_YOG,
  GET_ASTRO_FREE_REPORT_MANGLIK_REPORT,
  GET_ASTRO_FREE_REPORT_NUMEROLOGY,
  GET_ASTRO_FREE_REPORT_PITRA_DOSHA,
  GET_ASTRO_FREE_REPORT_POOJA,
  GET_ASTRO_FREE_REPORT_SADESATI_REPORT,
  GET_ASTRO_FREE_REPORT_VIMSHOTTARI_REPORT,
  GET_ASTRO_HOROSCOPE_PREDICTION,
  GET_ASTRO_KUNDLI_MATCH,
  GET_ASTRO_LAL_KITAB_HOUSES,
  GET_ASTRO_LAL_KITAB_PLANETS,
  GET_ASTRO_LOCATION,
  GET_ASTRO_MANGLIK_REPORT,
  GET_ASTRO_PANCHANG,
  GET_ASTRO_PANCHANG_CHOGHADIYA,
  GET_ASTRO_PANCHANG_HORA,
  GET_ASTRO_SUN_SIGN_PREDICTION,
  GET_ASTRO_TIMEZONE,
  GET_ASTRO_ZODIAC_COMPATIBILITY,
  GET_ASTRO_FREE_REPORT_PARTNER,
  GET_ASTRO_CALCULATOR_LOVE,
  GET_ASTRO_CALCULATOR_FRIENDSHIP,
  GET_ASTRO_FREE_REPORT_ANTAR_REPORT,
  GET_ASTRO_FREE_REPORT_PRATYANTAR_REPORT,
  GET_ASTRO_LOVE_CALCULATOR,
  GET_INTERNAL_LEADERBOARD_DATA,
} from "../utils/apiEndPoints";
import {
  AstroDailyPanchangData,
  AstroDashaReport,
  AstroFreeKundliAshtakvargaResponse,
  AstroFreeKundliBasicResponse,
  AstroFreeKundliDashaResponse,
  AstroFreeKundliKpResponse,
  AstroFreeKundliPlanetResponse,
  AstroFreeKundliReportResponse,
  AstroHoroscopeResponse,
  AstroKundliMatchResponse,
  AstroManglikResponse,
  AstroPanchangChoghadiyaResponse,
  AstroPredictionReq,
  AstroSunSignResponse,
  AstroUserData,
  AstroUserDataReq,
  AstroUserDetailsReq,
  AstroVimshottariReport,
  ChineseHoroScopeReport,
  CommonResponse,
  DashaPeriodType,
  GemstoneReport,
  GeoLocationRes,
  LoveCalculatorReq,
  LoveCalculatorRes,
  ObjectType,
  PoojaReport,
  UserAstroProfile,
  ZodiacCompatibilityRes,
  ZodiacCompatibilityType,
  SecretWishPlansResponse,
  CreateSecretWishReq,
  CreateSecretWishResponse,
  RomanticHoroscopeHomeResponse,
  CreateRomanticHoroscopeConnectionResponse,
  UpdateRomanticHoroscopeConnectionReq,
  UpdateRomanticHoroscopeConnectionResponse,
  RomanticHoroscopePlansResponse,
  CreateRomanticHoroscopePaymentOrderReq,
  RomanticHoroscopePaymentOrderResponse,
  AskRomanticHoroscopeQuestionReq,
  RomanticHoroscopeQuestionAnswerResponse,
  RomanticHoroscopeQuestionsChatResponse,
  InternalLeaderboardResponse,
} from "../modules/Astro/Enum";
import axios from "axios";
import axiosInstance from "../utils/customAxios";
import { AstroPageData } from "@/types/common.types";
import { promises } from "dns";

export const fetchTimeZone = async ({
  token,
  ...params
}: {
  date?: string;
  longitude: string;
  latitude: string;
  token: string;
}) => {
  try {
    const respData = await axiosInstance({
      method: "GET",
      url: GET_ASTRO_TIMEZONE,
      params: { ...params, token },
    });

    console.log("cccc-->>", respData);
    return respData.data as { timezone: string };
  } catch (e) {
    console.log(e);
  }
};

export const fetchLocationData = async (place: string, token: string = "") => {
  try {
    const respData = await axiosInstance({
      method: "GET",
      url: GET_ASTRO_LOCATION,
      params: { place, token },
    });

    return respData.data as GeoLocationRes;
  } catch (e) {
    console.log(e);
  }
};

export const fetchSunSignPrediction = async (data: AstroPredictionReq) => {
  try {
    const respData = await axiosInstance({
      method: "GET",
      url: GET_ASTRO_SUN_SIGN_PREDICTION,
      params: data,
    });

    return respData.data as AstroSunSignResponse;
  } catch (e) {
    console.log(e);
  }
};

export const fetchHoroscopePrediction = async (data: AstroPredictionReq) => {
  try {
    const respData = await axiosInstance({
      method: "GET",
      url: GET_ASTRO_HOROSCOPE_PREDICTION,
      params: data,
    });

    return respData.data as AstroHoroscopeResponse;
  } catch (e) {
    console.log(e);
  }
};

export const fetchPanchangData = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance({
      method: "GET",
      url: GET_ASTRO_PANCHANG,
      params: data,
    });

    return respData.data as AstroDailyPanchangData;
  } catch (e) {
    console.log(e);
  }
};

export const fetchKundliMatchDetails = async (
  data: AstroUserDataReq,
  token = ""
) => {
  try {
    const respData = await axiosInstance({
      method: "POST",
      url: GET_ASTRO_KUNDLI_MATCH,
      data,
      params: { token },
    });

    return respData.data as AstroKundliMatchResponse;
  } catch (e) {
    console.log(e);
  }
};

export const fetchManglikReport = async (
  data: AstroUserDataReq,
  token = ""
) => {
  try {
    const respData = await axiosInstance({
      method: "POST",
      url: GET_ASTRO_MANGLIK_REPORT,
      data,
      params: { token },
    });

    return respData.data as AstroManglikResponse;
  } catch (e) {
    console.log(e);
  }
};

export const fetchFreeKundliBasicDetails = async (
  data: AstroUserDetailsReq
) => {
  try {
    const respData = await axiosInstance<AstroFreeKundliBasicResponse>({
      method: "GET",
      url: GET_ASTRO_FREE_KUNDLI_BASIC,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchFreeKundliPlanetDetails = async (
  data: AstroUserDetailsReq
) => {
  try {
    const respData = await axiosInstance<AstroFreeKundliPlanetResponse>({
      method: "GET",
      url: GET_ASTRO_FREE_KUNDLI_PLANETS,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchFreeKundliChartImage = async (
  chartId: string,
  chartType: string,
  data: AstroUserDetailsReq
) => {
  try {
    const respData = await axiosInstance<{ svg: string }>({
      method: "GET",
      url: `${GET_ASTRO_FREE_KUNDLI_CHART}/${chartId}`,
      params: { ...data, ChartType: chartType },
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchFreeKundliKpDetails = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<AstroFreeKundliKpResponse>({
      method: "GET",
      url: GET_ASTRO_FREE_KUNDLI_KP,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchFreeKundliAshtakvargaDetails = async (
  data: AstroUserDetailsReq
) => {
  try {
    const respData = await axiosInstance<AstroFreeKundliAshtakvargaResponse>({
      method: "GET",
      url: GET_ASTRO_FREE_KUNDLI_ASHTAKVARGA,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchFreeKundliDashaDetails = async (
  data: AstroUserDetailsReq
) => {
  try {
    const respData = await axiosInstance<AstroFreeKundliDashaResponse>({
      method: "GET",
      url: GET_ASTRO_FREE_KUNDLI_DASHA,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchFreeKundliReportDetails = async (
  data: AstroUserDetailsReq
) => {
  try {
    const respData = await axiosInstance<AstroFreeKundliReportResponse>({
      method: "GET",
      url: GET_ASTRO_FREE_KUNDLI_REPORT,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchKaalsarpYogReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<AstroDashaReport>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_KAALSARP_YOG,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};
export const fetchManglikDoshaReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<AstroDashaReport>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_MANGLIK_REPORT,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};
export const fetchPitraDoshaReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<AstroDashaReport>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_PITRA_DOSHA,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};
export const fetchGemstonesReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<GemstoneReport>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_GEMSTONES,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchChineseHoroscopeReport = async (
  data: AstroUserDetailsReq
) => {
  try {
    const respData = await axiosInstance<ChineseHoroScopeReport>({
      method: "GET",
      url: GET_ASTRO_CHINESE_HOROSCOPE_PREDICTION,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};
export const fetchPoojaReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<PoojaReport>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_POOJA,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};
export const fetchSadesatiReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<AstroDashaReport>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_SADESATI_REPORT,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchVimshottariReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<AstroVimshottariReport>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_VIMSHOTTARI_REPORT,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchAntarDashaReport = async (
  data: AstroUserDetailsReq,
  md: string
) => {
  try {
    const respData = await axiosInstance<DashaPeriodType[]>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_ANTAR_REPORT,
      params: { ...data, md },
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchPratyantarDashaReport = async (
  data: AstroUserDetailsReq,
  md: string,
  ad: string
) => {
  try {
    const respData = await axiosInstance<DashaPeriodType[]>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_PRATYANTAR_REPORT,
      params: { ...data, md, ad },
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchNumerologyReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<AstroPageData[]>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_NUMEROLOGY,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchHoraReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<{
      hora: AstroPanchangChoghadiyaResponse;
    }>({
      method: "GET",
      url: GET_ASTRO_PANCHANG_HORA,
      params: data,
    });

    return respData?.data?.hora;
  } catch (e) {
    console.log(e);
  }
};

export const fetchChoghadiyaReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<{
      chaughadiya: AstroPanchangChoghadiyaResponse;
    }>({
      method: "GET",
      url: GET_ASTRO_PANCHANG_CHOGHADIYA,
      params: data,
    });

    return respData?.data?.chaughadiya;
  } catch (e) {
    console.log(e);
  }
};

export const fetchPartnerReport = async (data: {
  maleData: AstroUserDetailsReq;
  femaleData: AstroUserDetailsReq;
}) => {
  try {
    const respData = await axiosInstance<AstroDashaReport>({
      method: "POST",
      url: GET_ASTRO_FREE_REPORT_PARTNER,
      data,
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchLoveCalulatorReport = async (data: {
  maleData: AstroUserDetailsReq;
  femaleData: AstroUserDetailsReq;
}) => {
  try {
    const respData = await axiosInstance<{ love_report: string[] }>({
      method: "POST",
      url: GET_ASTRO_CALCULATOR_LOVE,
      data,
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchFriendshipReport = async (data: {
  maleData: AstroUserDetailsReq;
  femaleData: AstroUserDetailsReq;
}) => {
  try {
    const respData = await axiosInstance<{ friendship_report: string[] }>({
      method: "POST",
      url: GET_ASTRO_CALCULATOR_FRIENDSHIP,
      data,
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchZodiacCompatibility = async (
  data: ZodiacCompatibilityType
) => {
  try {
    const respData = await axiosInstance<ZodiacCompatibilityRes>({
      method: "GET",
      url: GET_ASTRO_ZODIAC_COMPATIBILITY,
      params: data,
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchLalKitabHouses = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<ObjectType[]>({
      method: "GET",
      url: GET_ASTRO_LAL_KITAB_HOUSES,
      params: data,
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchLalKitabPlanets = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<ObjectType[]>({
      method: "GET",
      url: GET_ASTRO_LAL_KITAB_PLANETS,
      params: data,
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchAstroProfiles = async (token: string = "") => {
  try {
    const respData = await axiosInstance<CommonResponse<UserAstroProfile[]>>({
      method: "GET",
      url: ASTRO_PROFILE,
      params: { token },
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const addAstroProfiles = async (reqBody: AstroUserData, token = "") => {
  try {
    console.log(token);
    const respData = await axiosInstance<CommonResponse<{}>>({
      method: "POST",
      url: ASTRO_PROFILE,
      params: { token },
      data: {
        firstName: reqBody?.name,
        lastName: reqBody?.lastName,
        dob: reqBody?.dob,
        tob: reqBody?.tob,
        pob: reqBody?.pob,
        gender: reqBody?.gender,
      },
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const deleteAstroProfile = async (id: number, token: string = "") => {
  try {
    const respData = await axiosInstance<CommonResponse<{}>>({
      method: "DELETE",
      url: ASTRO_PROFILE,
      params: {
        id: JSON.stringify(id),
        token,
      },
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const CalculateLove = async (
  reqBody: LoveCalculatorReq
): Promise<LoveCalculatorRes | undefined> => {
  try {
    const respData = await axiosInstance<LoveCalculatorRes>({
      method: "POST",
      url: GET_ASTRO_LOVE_CALCULATOR,
      data: reqBody,
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchSecretWishPlans = async () => {
  try {
    const respData = await axiosInstance<SecretWishPlansResponse>({
      method: "GET",
      url: GET_SECRET_WISH_PLANS,
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const createSecretWish = async (
  body: CreateSecretWishReq,
  token = ""
): Promise<CreateSecretWishResponse | undefined> => {
  try {
    /* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return */
    const response = await axiosInstance<CreateSecretWishResponse>({
      method: "POST",
      url: CREATE_SECRET_WISH,
      params: {
        token,
      },
      data: body,
    });
    return response?.data;
    /* eslint-enable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return */
  } catch (e) {
    console.log(e);
    return undefined;
  }
};

export const fetchRomanticHoroscopeQuestionsChat = async (
  token: string = ""
): Promise<RomanticHoroscopeQuestionsChatResponse | undefined> => {
  try {
    const respData =
      await axiosInstance<RomanticHoroscopeQuestionsChatResponse>({
        method: "GET",
        url: GET_ROMANTIC_HOROSCOPE_QUESTIONS_CHAT,
        params: { token },
      });

    return respData?.data;
  } catch (e) {
    if (axios.isAxiosError(e) && e.response) {
      return e.response.data as RomanticHoroscopeQuestionsChatResponse;
    }
    console.log(e);
  }
};

export const askRomanticHoroscopeQuestion = async (
  body: AskRomanticHoroscopeQuestionReq,
  token: string = ""
): Promise<RomanticHoroscopeQuestionAnswerResponse | undefined> => {
  try {
    const respData =
      await axiosInstance<RomanticHoroscopeQuestionAnswerResponse>({
        method: "POST",
        url: ASK_ROMANTIC_HOROSCOPE_QUESTION,
        params: { token },
        data: body,
      });

    return respData?.data;
  } catch (e) {
    if (axios.isAxiosError(e) && e.response) {
      return e.response.data as RomanticHoroscopeQuestionAnswerResponse;
    }
    console.log(e);
    return undefined;
  }
};

export const createRomanticHoroscopePaymentOrder = async (
  body: CreateRomanticHoroscopePaymentOrderReq,
  token: string = ""
): Promise<RomanticHoroscopePaymentOrderResponse | undefined> => {
  try {
    const respData = await axiosInstance<RomanticHoroscopePaymentOrderResponse>(
      {
        method: "POST",
        url: CREATE_ROMANTIC_HOROSCOPE_PAYMENT_ORDER,
        params: { token },
        data: body,
      }
    );

    return respData?.data;
  } catch (e) {
    if (axios.isAxiosError(e) && e.response) {
      return e.response.data as RomanticHoroscopePaymentOrderResponse;
    }
    console.log(e);
    return undefined;
  }
};

export const fetchRomanticHoroscopePlans = async (
  token: string = ""
): Promise<RomanticHoroscopePlansResponse | undefined> => {
  try {
    const respData = await axiosInstance<RomanticHoroscopePlansResponse>({
      method: "GET",
      url: GET_ROMANTIC_HOROSCOPE_PLANS,
      params: { token },
    });

    return respData?.data;
  } catch (e) {
    if (axios.isAxiosError(e) && e.response) {
      return e.response.data as RomanticHoroscopePlansResponse;
    }
    console.log(e);
  }
};

export const fetchRomanticHoroscopeHome = async (
  token: string = ""
): Promise<RomanticHoroscopeHomeResponse | undefined> => {
  try {
    const respData = await axiosInstance<RomanticHoroscopeHomeResponse>({
      method: "GET",
      url: GET_ROMANTIC_HOROSCOPE_HOME,
      params: { token },
    });

    return respData?.data;
  } catch (e) {
    if (axios.isAxiosError(e) && e.response) {
      return e.response.data as RomanticHoroscopeHomeResponse;
    }
    console.log(e);
  }
};

export const createRomanticHoroscopeConnection = async (
  body: UpdateRomanticHoroscopeConnectionReq,
  token: string = ""
): Promise<CreateRomanticHoroscopeConnectionResponse | undefined> => {
  try {
    const respData =
      await axiosInstance<CreateRomanticHoroscopeConnectionResponse>({
        method: "POST",
        url: UPDATE_ROMANTIC_HOROSCOPE_CONNECTION,
        params: { token },
        data: body,
      });

    return respData?.data;
  } catch (e) {
    if (axios.isAxiosError(e) && e.response) {
      return e.response.data as CreateRomanticHoroscopeConnectionResponse;
    }
    console.log(e);
    return undefined;
  }
};

export const updateRomanticHoroscopeConnection = async (
  body: UpdateRomanticHoroscopeConnectionReq,
  token: string = ""
): Promise<UpdateRomanticHoroscopeConnectionResponse | undefined> => {
  try {
    const respData =
      await axiosInstance<UpdateRomanticHoroscopeConnectionResponse>({
        method: "PUT",
        url: UPDATE_ROMANTIC_HOROSCOPE_CONNECTION,
        params: { token },
        data: body,
      });

    return respData?.data;
  } catch (e) {
    if (axios.isAxiosError(e) && e.response) {
      return e.response.data as UpdateRomanticHoroscopeConnectionResponse;
    }
    console.log(e);
    return undefined;
  }
};

export const getInternalLeaderboardData = async (
  token: string = ""
): Promise<InternalLeaderboardResponse | undefined> => {
  try {
    const resData = await axiosInstance<InternalLeaderboardResponse>({
      method: "GET",
      url: GET_INTERNAL_LEADERBOARD_DATA,
      params: { token },
    });
    return resData.data;
  } catch (e) {
    if (axios.isAxiosError(e) && e.response) {
      return e.response.data as InternalLeaderboardResponse;
    }
    console.log(e);
    return undefined;
  }
};
